import * as React from "react";
import { RampsStateContainer } from "../../containers/RampsStateContainer";
import { RampsPresenter } from "./RampsPresenter";

type Props = {};

export const Ramps: React.FC<Props> = () => {
  return (
    <RampsStateContainer isReference={false}>
      <RampsPresenter />
    </RampsStateContainer>
  );
};
